module.exports = __webpack_public_path__ + "img/Seccion_17_vector.a7cacd1f.png";